import type { LayoutConfig } from './dealCalculations'
import {
  mergeSuporteEvolucaoSlideLayout,
  isSuporteEvolucaoPlanName,
  SUPORTE_EVOLUCAO_SLIDE_LAYOUT,
} from './suporteEvolucaoSlideLayout'

/** POS Y do destaque de bônus no slide final do combo (planos genéricos). */
export const COMBO_BONUS_Y = 65.8

export function withComboPricingLayout(
  layout: LayoutConfig,
  planName?: string,
): LayoutConfig {
  if (planName && isSuporteEvolucaoPlanName(planName)) {
    return mergeSuporteEvolucaoSlideLayout(layout)
  }
  return { ...layout, bonusY: COMBO_BONUS_Y }
}

export function isComboPricingLayout(layout: LayoutConfig): boolean {
  const bonusY = layout.bonusY ?? 0
  if (Math.abs(bonusY - SUPORTE_EVOLUCAO_SLIDE_LAYOUT.bonusY!) < 0.15) return true
  return Math.abs(bonusY - COMBO_BONUS_Y) < 0.15
}
